<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="riskProfil">
                <div class="formControl mt">
                  <pr-input-column
                    label="Structure juridique"
                    [derrors]="derrors"
                  >
                    <mat-select formControlName="legalStructure">
                      @for (option of options1; track option) {
                        <mat-option [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
                <div class="formControl mt">
                  <pr-input-column
                    label="Valeur patrimoine"
                    [derrors]="derrors"
                  >
                    <mat-select formControlName="patrimonyValue">
                      @for (option of options2; track option) {
                        <mat-option [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer [form]="form" (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
